import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { GetPropertyPhotosDTO } from '../dtos';
import { getPropertyPhotos, picturesSelector, resetState } from '../feature';

export const useGetPropertyPhotos = (id: string) => {
  const { isLoading, propertyPhotosOutside, floorPlan, propertyPhotosInside } = useAppState(picturesSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!id) return;
    const dto = new GetPropertyPhotosDTO({ id });
    dispatch(getPropertyPhotos(dto));
  }, [id]);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, []);

  return useMemo(
    () => ({ isLoading, propertyPhotosOutside, floorPlan, propertyPhotosInside }),
    [isLoading, propertyPhotosOutside, floorPlan, propertyPhotosInside],
  );
};
